export default () => ({
  statements: [],
  statement: null,
  periodList: [],
  period: null,
})
